import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {IExgTab} from 'exc-tab-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExgTabV2ComponentHeaderElement} from '../../../misc/exg-tab-v2/exg-tab-v2.component';
import {EnumerationService} from '../../../services/enumeration.service';
import {DomSanitizer} from '@angular/platform-browser';
import {EditorComponent} from '@tinymce/tinymce-angular';
import {ExcSecurityService} from 'exc-security-v2';
import {forkJoin, of} from 'rxjs';
import {IExgEvent} from '../../../misc/interfaces/IExgEvent';
import {ExgApplicationEventEmitter} from 'src/app/misc/classes/ExgApplicationEventEmitter';
import {ICaseSummaryData} from '../../../misc/interfaces/ICaseSummaryData';
import {DataService} from '../../../services/data.service';
import {ExgEventArgs} from '../../../misc/classes/ExgEventArgs';
import {ApplicationService} from '../../../services/application.service';
import {MessageDataService} from '../../../services/message-data.service';

@Component({
  selector: 'app-tab-message-new-forcase',
  templateUrl: './tab-message-new-forcase.component.html',
  styles: []
})
export class TabMessageNewForcaseComponent extends ExcTranslation implements OnInit, IExgTab, IExgEvent {

  @ViewChild(EditorComponent) editor!: EditorComponent;
  Data: any;
  tabinstance: any;

  loading = true;
  Events: ExgApplicationEventEmitter = new ExgApplicationEventEmitter();
  rightDrawerVisible = false;
  rightTabs: ExgTabV2ComponentHeaderElement[] = [];

  _allowAddMode = false;

  Message: any;
  config = {
    showCc: false,
    showBcc: false,
    attachmentJagTable: {
      selected: [] as any[],
      selectedObjects: [] as any[]
    }
  };
  MessageSelectionHelper: any;
  selectedFilesHelper: any[] = [];

  repository = {
    data: {} as any,
    loadData: (data: any) => {
      this.msgDataSvc.Message.Repository.Get(data).subscribe((repData => {
        this.repository.data = repData;
      }));
    }
  };
  MCEinit: any = {
    placeholder: 'Hier klicken um Nachrichtentext einzugeben',
    formats: {
      bold: [{inline: 'span', styles: {fontWeight: 'bold'}}],
      italic: [{inline: 'span', styles: {fontStyle: 'italic'}}]
    },
    base_url: './tinymce',
    suffix: '.min',
    inline: false,
    height: '100%',
    resize: false,
    menubar: false,
    statusbar: false,

    plugins: ['paste'],

    valid_styles: {
      '*': 'font-weight,font-style,text-decoration,text-align,color,background-color'
    },

    // beim Paste alle font-family/size hart entfernen
    paste_preprocess: (plugin: any, args: any) => {
      // args.content ist ein HTML-String
      args.content = args.content
        .replace(/font-family\s*:\s*[^;"']+;?/gi, '')
        .replace(/font-size\s*:\s*[^;"']+;?/gi, '')
        .replace(/<font[^>]*>/gi, '')
        .replace(/<\/font>/gi, '');
    },
    content_style:
      '@import url(\'https://fonts.googleapis.com/css?family=Calibri\'); body { font-family: Calibri; font-size: 11pt; }',

    toolbar:
      'bold italic underline strikethrough| \
      alignleft aligncenter alignright alignjustify | \
      forecolor backcolor emoticons',
    contextmenu: 'bold italic underline strikethrough| \
      alignleft aligncenter alignright alignjustify | \
      forecolor backcolor emoticons EXAKTFieldInsert EXAKTTextblockInsert',
    setup: (editor: any) => {
      if (this.excSecurity.isFeatured('MSGFIELDINSERT')) {
        editor.ui.registry.addNestedMenuItem('EXAKTFieldInsert', {
          text: 'Feld einfügen',
          getSubmenuItems: () => {
            const rtVal: any[] = [];
            Object.keys(this.repository.data.Placeholder).forEach((key: string) => {
              // console.log(key, this.repository.data.Placeholder[key]);
              if (
                key.indexOf('oeID') === -1 && key.indexOf('oid') === -1 && key.indexOf('enmIdent') === -1
                && key.indexOf('enmName') === -1 && key.indexOf('PKey') === -1
                && this.repository.data.Placeholder[key]
              ) {
                rtVal.push({
                  type: 'menuitem',
                  text:
                    key.startsWith('vorg') || key.startsWith('au') ?
                      this.enumSvc.getFieldCaption(
                        key.startsWith('vorg') ? 'Vorgang' : key.startsWith('aue') ? 'AuftragE_EIS' : 'Auftrag'
                        , key
                      )
                      : key,
                  onAction: () => {
                    editor.insertContent(this.repository.data.Placeholder[key].toString());
                  }
                });
              }
            });

            return rtVal;
          }
        });
      }
      if (this.excSecurity.isFeatured('MSGAUTOTEXT')) {
        editor.ui.registry.addNestedMenuItem('EXAKTTextblockInsert', {
          text: 'Textvorlage einfügen',
          getSubmenuItems: () => {
            const rtVal: any[] = [];
            this.repository.data.Textbaustein.forEach((item: any) => {
              rtVal.push({
                type: 'menuitem',
                text: item.tbName,
                onAction: () => {
                  this.applyTextblock3(item.tbID);
                }
              });
            });
            return rtVal;
          }
        });
      }
    }
  };

  CaseSummary: ICaseSummaryData = this.dataSvc.Case.Summary.Get();

  constructor(private excRestService: ExcRestService,
              private cdr: ChangeDetectorRef,
              public enumSvc: EnumerationService,
              public sanitizer: DomSanitizer,
              public modalService: ExgModalService,
              public excSecurity: ExcSecurityService,
              private dataSvc: DataService,
              private msgDataSvc: MessageDataService,
              public appSvc: ApplicationService) {
    super();
  }

  ngOnInit(): void {
    this.registerEvents();
    this.initialize();
    this.Message.msg_objID = this.Data.objID;
    this.validateEnumerations();
    this.CaseSummary = this.dataSvc.Case.Summary.Get(this.Data.objID, undefined, {Events: this.Events});
    this.repository.loadData(this.Data.objID);
  }

  registerEvents(): void {
    this.enumSvc.repositoryLoaded.subscribe(() => {
      this.validateEnumerations();
    });
    this.Events.Case.Summary.DataLoaded.subscribe((evt: ExgEventArgs) => {
      if (evt.success) {
        this.tabinstance.Label = 'Neue Nachricht -' + this.CaseSummary.caseDetails.data.auNr;
        this.prepareMessage();
        this.validateEnumerations();
      }
    });
  }

  initialize(): void {
    const SELF = this;
    this._allowAddMode = SELF.excSecurity.isFeatured('MSGCREATE');

    SELF.rightTabs = [
      {
        get caption(): string {
          return SELF.getResource('Tabs.Case.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Case.Icon');
        }
      }
    ];
    SELF.MessageSelectionHelper = {
      msgEmpfaengerTo: [] as any[],
      msgEmpfaengerCc: [] as any[],
      msgEmpfaengerBcc: [] as any[]
    };
    SELF.Message = {
      msgID: ExcCoreModule.Guid.NewGuid(),
      msg_objID: undefined,
      msg_enmIdent_NachrichtTyp: this.enumSvc.getEnumerationDefaultValue('NachrichtTyp'),
      msg_enmIdent_NachrichtPrio: this.enumSvc.getEnumerationDefaultValue('NachrichtPrio'),
      msg_enmIdent_Postfach: this.enumSvc.getEnumerationDefaultValue('Postfach'),
      msgNachrichtKategorie_enmIdent: this.enumSvc.getEnumerationDefaultValue('NachrichtKategorie'),
      msgAbsender: undefined,
      msgBetreff: '',
      msgText: '',
      msgFIN: false,
      msgEmpfaengerTo: [] as any[],
      msgEmpfaengerCc: [] as any[],
      msgEmpfaengerBcc: [] as any[],
      msgAttachmentList: [] as any[],
      msgAttachmentLinkList: [] as any[]
    };
  }

  validateEnumerations(): void {
    this.enumSvc.getEnumerationList('NachrichtTyp', true).forEach(enm => {
      if (enm.enmIdent === 1) {
        enm.enmValid = this.excSecurity.isFeatured('MSGINTERNAL');
      }
      if (enm.enmIdent === 2) {
        enm.enmValid = this.excSecurity.isFeatured('MSGEMAIL');
      }
      if (enm.enmIdent === 3) {
        enm.enmValid = false;
      }
      if (enm.enmIdent === 4) {
        enm.enmValid = false;
      }
      if (
        enm.enmIdent === 5
        &&
        this.CaseSummary?.caseDetails
        &&
        this.CaseSummary?.caseDetails?.data?.showGDVActions !== 1
      ) {
        enm.enmValid = false;
      } else if (
        enm.enmIdent === 5
        &&
        this.CaseSummary?.caseDetails
        &&
        this.CaseSummary?.caseDetails?.data?.showGDVActions === 1
      ) {
        enm.enmValid = true;
      }
    });
  }

  selectContacts(field: string): void {
    this.modalService.show('ModalMessageContactSelectorComponent', {
      type: this.Message.msg_enmIdent_NachrichtTyp,
      oid: this.CaseSummary.ID,
      selected: this.MessageSelectionHelper[field], selectedObjects: this.Message[field]
    }).subscribe((result: any) => {
      if (result && result.changed) {
        this.MessageSelectionHelper[field] = result.selected;
        this.Message[field] = result.selectedObjects;
      }
    });
  }

  prepareMessage(): void {
    if (this.Data.dmsgID) {
      this.applyDefaultMessage();
    } else {
      this.applyDefaultRecipientAndType();
    }
    const item = this.enumSvc.getEnumerationList('Postfach').find((e) => {
      return e.enmSelector === this.CaseSummary.caseDetails.data.au_oeID_Auftraggeber;
    }) || this.enumSvc.getEnumerationDefaultItem('Postfach');
    this.changeMessageSender({index: 0, value: item});

    if (((this.Message.msgBetreff
        && this.Message.msgBetreff.length === 0) || !this.Message.msgBetreff)
      && this.CaseSummary.caseDetails.data.auNr
    ) {
      this.Message.msgBetreff = this.CaseSummary.caseDetails.data.auNr;
    }
  }

  applyDefaultMessage(): void {
    this.excRestService.get(this.excRestService.computeUrl('DefaultMessageR_FilledNEW', {dmsgID: this.Data.dmsgID, objID: this.Data.objID}))
      .subscribe((ret: any) => {
        this.Message.msgBetreff = ret.data.StandardnachrichtHeader.dmsgBetreff;
        this.Message.msgText = ret.data.StandardnachrichtHeader.dmsgText;
        this.Message.msg_enmIdent_NachrichtTyp = ret.data.StandardnachrichtHeader.dmsgTyp;
        if (ret.data.StandardnachrichtHeader.dmsgToID !== null && ret.data.StandardnachrichtHeader.dmsgID !== null) {
          this.Message.msgEmpfaengerTo.push({
            kontID: ret.data.StandardnachrichtHeader.dmsgToID,
            kontVal: ret.data.StandardnachrichtHeader.dmsgTo
          });
          this.MessageSelectionHelper.msgEmpfaengerTo.push(ret.data.StandardnachrichtHeader.dmsgToID.toLowerCase());
        }
        if (ret.data.StandardnachrichtCcList && ret.data.StandardnachrichtCcList.length > 0) {
          for (let i = 0; i < ret.data.StandardnachrichtCcList.length; i++) {
            if (this.Message.msgEmpfaengerTo.filter(
              (e: any) => e.kontVal.toLowerCase() === ret.data.StandardnachrichtCcList[i].cc.toLowerCase()).length === 0
              && this.Message.msgEmpfaengerCc.filter(
                (e: any) => e.kontVal.toLowerCase() === ret.data.StandardnachrichtCcList[i].cc.toLowerCase()).length === 0) {
              this.Message.msgEmpfaengerCc.push({
                kontID: ret.data.StandardnachrichtCcList[i].ccID,
                kontVal: ret.data.StandardnachrichtCcList[i].cc
              });
            }
            this.MessageSelectionHelper.msgEmpfaengerCc.push(ret.data.StandardnachrichtCcList[i].ccID.toLowerCase());
          }
          this.config.showCc = true;
        }
        if (ret.data.StandardnachrichtHeader.dmsgBccID !== null && ret.data.StandardnachrichtHeader.dmsgID !== null
          && (this.Message.msgEmpfaengerTo.filter(
            (e: any) => e.kontVal.toLowerCase() === ret.data.StandardnachrichtHeader.dmsgBcc.toLowerCase()).length === 0
            && this.Message.msgEmpfaengerCc.filter(
              (e: any) => e.kontVal.toLowerCase() === ret.data.StandardnachrichtHeader.dmsgBcc.toLowerCase()).length === 0)) {
          this.Message.msgEmpfaengerBcc.push({
            kontID: ret.data.StandardnachrichtHeader.dmsgBccID,
            kontVal: ret.data.StandardnachrichtHeader.dmsgBcc
          });
          this.MessageSelectionHelper.msgEmpfaengerBcc.push(ret.data.StandardnachrichtHeader.dmsgBccID.toLowerCase());
          this.config.showBcc = true;
        }
        this.loading = false;
      });
  }

  applyDefaultRecipientAndType(): void {
    if (this.excSecurity.isFeatured('MSGEMAIL')) {
      this.Message.msg_enmIdent_NachrichtTyp = 2;
      const auAnsprechpartner = this.CaseSummary.oeList.data.find((value) => {
        return this.CaseSummary.caseDetails.data.au_oeId_Ansprechpartner?.toLowerCase() === value.oeID?.toLowerCase();
      });
      if (auAnsprechpartner) {
        const cont = auAnsprechpartner.contacts.find((value: any) => {
          return value.kont_enmIdent_KontaktTyp === 28;
        });

        if (cont) {
          this.MessageSelectionHelper['msgEmpfaengerTo'].push(cont.kontID);
          this.Message['msgEmpfaengerTo'].push(cont);
        }
      }
    }
    this.loading = false;
  }

  changeMessageCategory($event: { index: number; value: any }): void {
    this.Message.msgNachrichtKategorie_enmIdent = $event.value.enmIdent;
  }

  changeMessagePriority($event: { index: number; value: any }): void {
    this.Message.msg_enmIdent_NachrichtPrio = $event.value.enmIdent;
  }

  changeMessageSender($event: { index: number; value: any }): void {
    this.Message.msg_enmIdent_Postfach = $event.value.enmIdent;
    this.Message.msgAbsender = $event.value.enmTextA;
  }

  changeMessageType($event: { index: number; value: any }): void {
    if (this.Message.msg_enmIdent_NachrichtTyp === $event.value.enmIdent) {
      return;
    }
    this.Message.msg_enmIdent_NachrichtTyp = $event.value.enmIdent;
    this.Message.msgEmpfaengerTo = [];
    this.MessageSelectionHelper.msgEmpfaengerTo = [];
    this.Message.msgEmpfaengerCc = [];
    this.MessageSelectionHelper.msgEmpfaengerCc = [];
    this.Message.msgEmpfaengerBcc = [];
    this.MessageSelectionHelper.msgEmpfaengerBcc = [];
  }

  applyTextblock3(tbID: string): void {
    const obs1 = this.excRestService.get(this.excRestService.computeUrl('TextblockR_Filled', {tbID, oid: this.Message.msg_objID}));
    const obs2 = (this.Message.msgBetreff.length === 0 && this.Message.msgText.length === 0) ? of(true) :
      this.modalService.showSimple('Vorlage einfügen'
        , 'Möchten Sie die vorhandenen Texte beibehalten?'
        , true
        , true
        , 'Beibehalten'
        , 'Ersetzen', true);

    forkJoin([obs1, obs2]).subscribe((e: any[]) => {
      if (e && !e[1]) {
        this.Message.msgBetreff = '';
        this.Message.msgText = '';
      }
      if (e && e[0] && e[0].success && e[0].data) {
        this.Message.msgBetreff = e[0].data.tbTextShort + ((this.Message.msgBetreff.length) > 0 ? ' | ' : '') + this.Message.msgBetreff;
        this.Message.msgText = e[0].data.tbText + ((this.Message.msgText.length) > 0 ? ' <hr /> ' : '') + this.Message.msgText;
      }
      this.cdr.detectChanges();
    });
  }

  send(): void {
    if (
      (this.Message.msgEmpfaengerTo.length + this.Message.msgEmpfaengerBcc.length + this.Message.msgEmpfaengerCc.length) > 0
      && this.Message.msgBetreff.length > 0
    ) {
      const checkFilenames = this.config.attachmentJagTable.selectedObjects.filter(file => {
        return file.dokName.indexOf(this.CaseSummary.caseDetails.data.auNr.replace('.00', '')) === -1
          && file.dokName.indexOf(this.CaseSummary.caseDetails.data.aueSchadenNr) === -1;
      });
      if (checkFilenames.length > 0 && this.Message.msg_enmIdent_NachrichtTyp === 2)
      {
        this.modalService.showSimple('Bestätigung erforderlich'
          , 'Es wurden Dateien ausgewählt, die nicht die Auftragsnummer oder die Schadennummer im Namen enthalten. Möchten Sie die Nachricht trotzdem senden?'
          , true
          , true
          , 'Ja, senden'
          , 'Nein, abbrechen', true)
          .subscribe((resp: any) => {
            if (resp)
            {
              this.finalSend();
            }
          });
      } else {
        this.finalSend();
      }
    }
  }

  finalSend(): void {
    this.Message.msgAttachmentLinkList.length = 0;
    this.config.attachmentJagTable.selected.forEach((row: any) => {
      this.Message.msgAttachmentLinkList.push({ID: row});
    });
    this.excRestService.post(this.excRestService.computeUrl('MessageC')
      , this.Message).subscribe((e: any) => {
        if (e.success) {
          this.modalService.showToast('Mail wurde gesendet', 'md-toast success');
          this.Message.msgID = ExcCoreModule.Guid.NewGuid();
          this.tabinstance.Config.Close();
          this.tabinstance.Close();
        }
      }
    );
  }

  onContactToChipClose($event: { item: any; index: number }): void {
    this.Message.msgEmpfaengerTo.splice($event.index, 1);
    this.MessageSelectionHelper.msgEmpfaengerTo.splice($event.index, 1);
  }

  onContactCcChipClose($event: { item: any; index: number }): void {
    this.Message.msgEmpfaengerCc.splice($event.index, 1);
    this.MessageSelectionHelper.msgEmpfaengerCc.splice($event.index, 1);
  }

  onContactBccChipClose($event: { item: any; index: number }): void {
    this.Message.msgEmpfaengerBcc.splice($event.index, 1);
    this.MessageSelectionHelper.msgEmpfaengerBcc.splice($event.index, 1);
  }

  onAttachmentChipClose($event: { item: any; index: number }): void {
    this.config.attachmentJagTable.selectedObjects.splice($event.index, 1);
    this.config.attachmentJagTable.selected.splice($event.index, 1);
  }

  onAttachmentFileChipClose($event: { item: any; index: number }): void {
    this.selectedFilesHelper.splice($event.index, 1);
    this.Message.msgAttachmentList.splice($event.index, 1);
  }

  openAttachmentMgmt(): void {
    this.modalService.show('ModalMessageAttachmentSelectorComponent',
      {
        attachmentLink: this.config.attachmentJagTable.selected,
        attachmentLinkObjects: this.config.attachmentJagTable.selectedObjects,
        attachmentJagData: this.CaseSummary.attachmentJagTable.jagdata,
        attachmentObjects: this.selectedFilesHelper,
        attachment: this.Message.msgAttachmentList,
        msgID: this.Message.msgID
      }).subscribe((ret: any) => {
        this.config.attachmentJagTable.selected = ret.attachmentLink;
        this.config.attachmentJagTable.selectedObjects = ret.attachmentLinkObjects;
        this.Message.msgAttachmentList = ret.attachment;
        this.selectedFilesHelper = ret.attachmentObjects;
      }
    );
  }

  close(): void {
    this.modalService.showSimple('Eingaben verwerfen?',
      'Sollen alle Eingaben verworfen und das Fenster geschlossen werden?',
      true,
      true,
      'Verwerfen',
      'Abbrechen').subscribe(answer => {
      if (answer) {
        this.tabinstance.Close();
      }
    });

  }
}
